var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoalbum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 285.61 293.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(51,51,51)",
      strokeWidth: 200,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-285.62, -293.89)",
    d: "M 59.2 31.2 Q 59 31 54.5 31 Q 50 31 34 30.5 Q 18 30 -1.5 30.5 Q -21 31 -39 36 Q -57 41 -69.5 45.5 Q -82 50 -91 55.5 Q -100 61 -100.5 61 Q -101 61 -67.5 52 Q -34 43 -6.5 36.5 Q 21 30 62.5 23 Q 104 16 141.5 12.5 Q 179 9 203.5 8 Q 228 7 213.5 12 Q 199 17 170.5 27.5 Q 142 38 102.5 51.5 Q 63 65 11 80.5 Q -41 96 -92 110.5 Q -143 125 -172.5 135.5 Q -202 146 -205.5 147.5 Q -209 149 -205.5 148.5 Q -202 148 -133.5 126.5 Q -65 105 1 89 Q 67 73 133 61 Q 199 49 254.5 43.5 Q 310 38 325.5 37 Q 341 36 327.5 39.5 Q 314 43 264.5 57 Q 215 71 148 90 Q 81 109 14 129 Q -53 149 -99 162 Q -145 175 -155 177.5 Q -165 180 -153.5 176.5 Q -142 173 -90 159.5 Q -38 146 22.5 134 Q 83 122 148.5 110.5 Q 214 99 260 92.5 Q 306 86 319.5 83.5 Q 333 81 321.5 80.5 Q 310 80 266 85 Q 222 90 156.5 104.5 Q 91 119 25.5 143.5 Q -40 168 -88.5 192.5 Q -137 217 -157 229 Q -177 241 -175.5 241 Q -174 241 -143 230 Q -112 219 -53 198.5 Q 6 178 75.5 153 Q 145 128 213.5 101 Q 282 74 335 52 Q 388 30 413 18.5 Q 438 7 438.5 6.5 Q 439 6 419 8 Q 399 10 362.5 25.5 Q 326 41 278.5 67 Q 231 93 173 123.5 Q 115 154 59 181.5 Q 3 209 -15 218.5 Q -33 228 -26.5 225.5 Q -20 223 18 205.5 Q 56 188 114.5 164.5 Q 173 141 240.5 117 Q 308 93 375 72.5 Q 442 52 482 42 Q 522 32 526 31 Q 530 30 508.5 37.5 Q 487 45 440 65 Q 393 85 320 115 Q 247 145 172 174 Q 97 203 33 230 Q -31 257 -68 277.5 Q -105 298 -110.5 303 Q -116 308 -89 299 Q -62 290 -1.5 266 Q 59 242 134.5 210.5 Q 210 179 292 150.5 Q 374 122 442.5 102.5 Q 511 83 544.5 74 Q 578 65 571 67 Q 564 69 517.5 91 Q 471 113 390.5 153 Q 310 193 212.5 235 Q 115 277 24.5 315 Q -66 353 -125.5 380.5 Q -185 408 -205.5 422.5 Q -226 437 -218 437 Q -210 437 -162 420 Q -114 403 -40.5 372 Q 33 341 119 303 Q 205 265 293.5 232 Q 382 199 456 176.5 Q 530 154 565.5 144.5 Q 601 135 596.5 135.5 Q 592 136 544 155.5 Q 496 175 417.5 210 Q 339 245 252 285.5 Q 165 326 86.5 361.5 Q 8 397 -36.5 419.5 Q -81 442 -90 448.5 Q -99 455 -73.5 446.5 Q -48 438 13 415.5 Q 74 393 160.5 359.5 Q 247 326 337.5 294 Q 428 262 499 239.5 Q 570 217 608 204.5 Q 646 192 640.5 191.5 Q 635 191 586 207.5 Q 537 224 452.5 260 Q 368 296 270 338 Q 172 380 80 414 Q -12 448 -60.5 466.5 Q -109 485 -113.5 487.5 Q -118 490 -90 482 Q -62 474 0.5 455.5 Q 63 437 149 412.5 Q 235 388 320.5 367 Q 406 346 482 330 Q 558 314 596.5 305.5 Q 635 297 638 295.5 Q 641 294 608 303 Q 575 312 504 338.5 Q 433 365 387 383 Q 341 401 202 446.5 Q 63 492 11.5 507 Q -40 522 -46.5 524.5 Q -53 527 -15 512.5 Q 23 498 99 475.5 Q 175 453 273.5 425.5 Q 372 398 464.5 373 Q 557 348 637.5 327.5 Q 718 307 754.5 301.5 Q 791 296 781 299.5 Q 771 303 715 322.5 Q 659 342 563 375 Q 467 408 384.5 440 Q 302 472 240.5 496.5 Q 179 521 151 533 Q 123 545 128.5 543.5 Q 134 542 186 526.5 Q 238 511 317 490.5 Q 396 470 479.5 452 Q 563 434 633.5 421 Q 704 408 727 406 Q 750 404 732.5 411.5 Q 715 419 643 443.5 Q 571 468 481 495.5 Q 391 523 330.5 543.5 Q 270 564 244 572.5 Q 218 581 225.5 578.5 Q 233 576 273 563 Q 313 550 375.5 535 Q 438 520 507 507 Q 576 494 630 487.5 Q 684 481 707.5 482.5 Q 731 484 722 492.5 Q 713 501 669 516.5 Q 625 532 563 546 Q 501 560 458 570 Q 415 580 409.5 581 Q 404 582 425 578 Q 446 574 500 568 Q 554 562 616.5 556.5 Q 679 551 736.5 546.5 L 794.2 541.8",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.86 0 0 0.86 256.38 256.38)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120 144)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136, -400)",
    d: "M 144 288 h -32 v 224 h 32 c 8.8 0 16 -7.2 16 -16 v -192 c 0 -8.8 -7.2 -16 -16 -16 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120 144)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-376, -400)",
    d: "M 368 288 c -8.801 0 -16 7.2 -16 16 v 192 c 0 8.8 7.199 16 16 16 h 32 v -224 h -32 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -255.43)",
    d: "M 512 256 c 0 -141.385 -114.615 -256 -256 -256 s -256 114.615 -256 256 c 0 30.706 5.415 60.145 15.328 87.424 c -9.739 16.603 -15.328 35.935 -15.328 56.576 c 0 56.423 41.724 103.094 96 110.858 v -221.709 c -15.957 2.283 -30.832 7.921 -43.877 16.189 c -2.696 -13.359 -4.123 -27.182 -4.123 -41.338 c 0 -114.875 93.125 -208 208 -208 s 208 93.125 208 208 c 0 14.157 -1.415 27.984 -4.11 41.348 c -13.05 -8.273 -27.927 -13.924 -43.89 -16.209 v 221.72 c 54.274 -7.766 96 -54.437 96 -110.857 c 0 -20.637 -5.589 -39.967 -15.324 -56.569 c 9.914 -27.283 15.324 -56.726 15.324 -87.433 z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoalbum);
export default __webpack_public_path__ + "static/media/noalbum.317b8fb743f80929b8db2be24529d4be.svg";
export { ForwardRef as ReactComponent };